import Image from 'next/image';
import Link from 'next/link';

import OzonLogo from '@shared/assets/icons/ozon.svg';
import WbLogo from '@shared/assets/icons/wb.svg';
import YaMarketLogo from '@shared/assets/icons/ya-market.svg';
import { ID_OZON_LINK, ID_WB_LINK, ID_YANDEX_MARKET_LINK } from '@shared/constants/keys';
import { useAppSelector } from '@shared/hooks/redux';
import { Metrics } from '@shared/types/enums/metrics.enum';
import { HStack } from '@shared/ui/Stack';
import { sendMetrics } from '@shared/utils/sendMetrics/sendMetrics';

import cls from './MarketplaceLinks.module.scss';

export const MarketplaceLinks = () => {
  const props = useAppSelector((state) => state.product.data.props);

  const wbLink = props[ID_WB_LINK]?.values[0]?.value;
  const ozonLink = props[ID_OZON_LINK]?.values[0]?.value;
  const yandexMarketLink = props[ID_YANDEX_MARKET_LINK]?.values[0]?.value;

  if (!wbLink && !ozonLink && !yandexMarketLink) {
    return null;
  }

  return (
    <div className={cls.wrap}>
      <div className={cls.title}>Доступно на маркетплейсах</div>
      <HStack className={cls.buttonsWrap}>
        {wbLink && (
          <Link
            className={cls.button}
            href={wbLink}
            target={'_blank'}
            onClick={() => sendMetrics(Metrics.GOTO_WB)}
          >
            <Image
              src={WbLogo}
              alt={'Ссылка на Wildberries'}
            />
          </Link>
        )}
        {ozonLink && (
          <Link
            className={cls.button}
            href={ozonLink}
            target={'_blank'}
            onClick={() => sendMetrics(Metrics.GOTO_OZON)}
          >
            <Image
              src={OzonLogo}
              alt={'Ссылка на Ozon'}
            />
          </Link>
        )}
        {yandexMarketLink && (
          <Link
            className={cls.button}
            href={yandexMarketLink}
            target={'_blank'}
            onClick={() => sendMetrics(Metrics.GOTO_YM)}
          >
            <Image
              src={YaMarketLogo}
              alt={'Ссылка на Яндекс Маркет'}
            />
          </Link>
        )}
      </HStack>
    </div>
  );
};
